module.exports = __webpack_public_path__ + "img/logo-20.3f494c0a.png";